//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import DummyPoster from '../../images/texture-v2.png';
import VideoModal from '../vue/VideoModal.vue';

export default {
  data() {
      return {
        show: false,
        dummy_poster: DummyPoster,
      };
  },
  
  props: {
    title: {
      type: String,
      default: 'A different approach',
    },
    content: {
      type: String,
      default: 'BPB Auto ...',
    },
    arrow: {
      type: String,
      default: '',
    },
    arrowUrl: {
      type: String,
      default: '',
    },
    videoPoster: {},
    videoUrl: {},
  },
  
  computed: {

  },
  
  watch: {

  },
  
  methods: {

  },
  
  components: {
    VideoModal,
  },
  
  created() {
    
  },
  mounted() {

  },
};




// WEBPACK FOOTER //
// ./scripts/vue/IntroBanner.vue